import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-sap-submittal-failure',
  imports: [
    TranslatePipe,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './sap-submittal-failure.component.html',
  styleUrl: './sap-submittal-failure.component.scss',
})
export class SapSubmittalFailureComponent {

}
